import { LitePanel } from './components/LitePanel'
import { SecondScreen } from './components/SecondScreen'
import { RecorderPopup } from './components/RecorderPopup'
import { CallRecordingProvider } from './contexts/CallRecordingContext'

function App() {
  // Check URL params for view mode
  const urlParams = new URLSearchParams(window.location.search)
  const view = urlParams.get('view')
  const mode = urlParams.get('mode')

  // Render SecondScreen for second monitor view
  if (view === 'secondscreen' || view === 'second') {
    return <SecondScreen />
  }

  // Render popup recorder (opened from iframe)
  if (mode === 'recorder') {
    return (
      <CallRecordingProvider>
        <RecorderPopup />
      </CallRecordingProvider>
    )
  }

  // Default to LitePanel (embedded widget) with recording support
  return (
    <CallRecordingProvider>
      <LitePanel />
    </CallRecordingProvider>
  )
}

export default App
